<div mat-dialog-title>{{ 'UNAUTHORIZED_DIALOG.title' | translate }}</div>
<mat-dialog-content>
  <div><mat-icon class="red">highlight_off</mat-icon></div>
  <div>{{ 'UNAUTHORIZED_DIALOG.content' | translate }}</div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-flat-button color="primary" (click)="logout()">
    {{ 'UNAUTHORIZED_DIALOG.primary_btn' | translate }}
  </button>
</mat-dialog-actions>
